import { render, staticRenderFns } from "./download_yn.vue?vue&type=template&id=667645a6&scoped=true&"
import script from "./download_yn.vue?vue&type=script&lang=js&"
export * from "./download_yn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667645a6",
  null
  
)

export default component.exports